import { type FunctionComponent } from "react";

import { Container, StyledArrowIcon, Title } from "./styles";

type Props = {
  className?: string;
  onClick?: () => void;
  title: string;
};

export const PlusArchiveTitle: FunctionComponent<Props> = ({ className, onClick, title }) => (
  <Container $isLink={!!onClick} className={className} onClick={onClick}>
    <Title>{title}</Title>
    <StyledArrowIcon />
  </Container>
);

PlusArchiveTitle.displayName = "PlusArchiveTitle";
